import { useEffect } from "react";

import { usePatientStore, useUserStore } from "~/stores";

export const useCleanUpScreeningsStores = () => {
  const clearAppointmentDetails = usePatientStore(
    (state) => state.clearAppointmentDetails,
  );
  const clearInsuranceData = usePatientStore(
    (state) => state.clearInsuranceData,
  );
  const clearHasFileSizeError = usePatientStore(
    (state) => state.clearHasFileSizeError,
  );

  const setState = useUserStore((state) => state.setState);
  const setInsurance = useUserStore((state) => state.setInsurance);

  useEffect(() => {
    setState(null);
    setInsurance(null);
    clearAppointmentDetails();
    clearInsuranceData();
    clearHasFileSizeError();
  }, [
    setState,
    setInsurance,
    clearAppointmentDetails,
    clearInsuranceData,
    clearHasFileSizeError,
  ]);
};
